import React from "react";
import { useHistory, useParams, useRouteMatch } from "react-router-dom";
import Title from "../../common/components/view/ViewTitle";
import View from "../../common/components/view/View";
import ViewHeader from "../../common/components/view/ViewHeader";
import FormField from "../../common/components/form/FormField";
import FormFieldInput from "../../common/components/form/FormFieldInput";
import TypeaheadInput from "../../common/components/input/TypeaheadInput";
import Form from "../../common/components/form/Form";
import { useForm, OnSubmit } from "react-hook-form";
import FormSubmit from "../../common/components/form/FormSubmit";
import FormFieldErrors from "../../common/components/form/FormFieldErrors";
import ViewContent from "../../common/components/view/ViewContent";
import { useScorecardTypesQuery } from "../graphql";
import HorizontalSpacer from "../../common/components/layout/HorizontalSpacer";
import Button from "../../common/components/input/Button";
import FormFieldLabel from "../../common/components/form/FormFieldLabel";

interface FormData {
  type: string;
}

const ScorecardTypeView: React.FC = () => {
  const history = useHistory();
  const match = useRouteMatch();
  const formContext = useForm<FormData>();
  const params = useParams<{ job: string }>();
  const { data, loading } = useScorecardTypesQuery({
    variables: { job: params.job }
  });

  const onSubmit: OnSubmit<FormData> = data => {
    history.push(`${match.url}/${data.type}/page/1`);
  };

  const onBack = () => {
    history.push("/scorecard");
  };

  return (
    <View>
      <ViewHeader>
        <Title>Scorecard Selection</Title>
      </ViewHeader>
      <ViewContent loading={loading}>
        {data && data.scorecardTypes && (
          <Form context={formContext} onSubmit={onSubmit}>
            <FormField
              name="type"
              rules={{
                required: "The scorecare type field is required."
              }}
            >
              <FormFieldLabel>Scorecard Type</FormFieldLabel>
              <FormFieldInput>
                <TypeaheadInput
                  items={data.scorecardTypes.map(group => ({
                    value: group.code,
                    title: group.description
                  }))}
                />
              </FormFieldInput>
              <FormFieldErrors />
            </FormField>
            <div className="flex-grow" />
            <div className="flex">
              <Button className="w-full" onClick={onBack}>
                Back
              </Button>
              <HorizontalSpacer />
              <FormSubmit>Continue</FormSubmit>
            </div>
          </Form>
        )}
      </ViewContent>
    </View>
  );
};

export default ScorecardTypeView;
